import { API_METHOD, NAMESPACE_API_PATH } from '~/app/shared/utils/consts/api';

export const ChangeIbanApi = $api => {
  $api.register('change-iban-api', NAMESPACE_API_PATH.PRIVATE, request => ({
    changeBankRequisite(payload) {
      return request(API_METHOD.PUT, '/bank-requisite/change', payload);
    },
  }));
};
